import axiosInstance from "auth/FetchInterceptor";
import {
    VEHICLE_EXPENSE_API,
    VEHICLE_EXPENSE_CATEGORIES,
    VEHICLE_EXPENSE_GET_ALL,
    VEHICLE_EXPENSE_SUMMARY,
    VEHICLE_EXPENSE_APPROVE,
    VEHICLE_EXPENSE_PAY,
    EXPORT_VEHICLE_EXPENSE,
} from "constants/ApiConstant";

const VehicleExpenseService = {};

VehicleExpenseService.getCategories = function () {
    return axiosInstance.get(VEHICLE_EXPENSE_CATEGORIES, null);
};

VehicleExpenseService.createCategory = function (data) {
    return axiosInstance.post(VEHICLE_EXPENSE_CATEGORIES, data);
};

VehicleExpenseService.updateCategory = function (data) {
    return axiosInstance.put(VEHICLE_EXPENSE_CATEGORIES, data);
};

VehicleExpenseService.deleteCategory = function (id) {
    return axiosInstance.delete(`${VEHICLE_EXPENSE_CATEGORIES}/${id}`, null);
};

VehicleExpenseService.getAll = function (data) {
    return axiosInstance.post(VEHICLE_EXPENSE_GET_ALL, data);
};

VehicleExpenseService.getSummary = function (data) {
    return axiosInstance.post(VEHICLE_EXPENSE_SUMMARY, data);
};

VehicleExpenseService.getById = function (id) {
    return axiosInstance.get(`${VEHICLE_EXPENSE_API}/${id}`, null);
};

VehicleExpenseService.create = function (data) {
    return axiosInstance.post(VEHICLE_EXPENSE_API, data);
};

VehicleExpenseService.update = function (data) {
    return axiosInstance.put(VEHICLE_EXPENSE_API, data);
};

VehicleExpenseService.delete = function (id) {
    return axiosInstance.delete(`${VEHICLE_EXPENSE_API}/${id}`, null);
};

VehicleExpenseService.approve = function (data) {
    return axiosInstance.put(VEHICLE_EXPENSE_APPROVE, data);
};

VehicleExpenseService.pay = function (data) {
    return axiosInstance.put(VEHICLE_EXPENSE_PAY, data);
};

VehicleExpenseService.exportExcel = function (data) {
    return axiosInstance.post(EXPORT_VEHICLE_EXPENSE, data, {
        headers: {
            'Content-Type': 'application/json',
        },
        responseType: "blob",
    });
};

export default VehicleExpenseService;